/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Statsbar_Giveawaystodate3Inputs */

const id_home_statsbar_giveawaystodate3 = /** @type {(inputs: Home_Statsbar_Giveawaystodate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaway hingga Saat Ini`)
};

const ms_home_statsbar_giveawaystodate3 = /** @type {(inputs: Home_Statsbar_Giveawaystodate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemberian Setakat Ini`)
};

const da_home_statsbar_giveawaystodate3 = /** @type {(inputs: Home_Statsbar_Giveawaystodate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaways til dato`)
};

const de_home_statsbar_giveawaystodate3 = /** @type {(inputs: Home_Statsbar_Giveawaystodate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaways bisher`)
};

const en_us2_home_statsbar_giveawaystodate3 = /** @type {(inputs: Home_Statsbar_Giveawaystodate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaways to Date`)
};

const es_es2_home_statsbar_giveawaystodate3 = /** @type {(inputs: Home_Statsbar_Giveawaystodate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juegos gratis hasta ahora`)
};

const es_mx2_home_statsbar_giveawaystodate3 = /** @type {(inputs: Home_Statsbar_Giveawaystodate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regalos hasta la fecha`)
};

const fil_home_statsbar_giveawaystodate3 = /** @type {(inputs: Home_Statsbar_Giveawaystodate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Giveaway Hanggang Ngayon`)
};

const fr_home_statsbar_giveawaystodate3 = /** @type {(inputs: Home_Statsbar_Giveawaystodate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratuités à ce jour`)
};

const it_home_statsbar_giveawaystodate3 = /** @type {(inputs: Home_Statsbar_Giveawaystodate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaway fino ad oggi`)
};

const hu_home_statsbar_giveawaystodate3 = /** @type {(inputs: Home_Statsbar_Giveawaystodate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajándékok eddig`)
};

const nl_home_statsbar_giveawaystodate3 = /** @type {(inputs: Home_Statsbar_Giveawaystodate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaways tot nu toe`)
};

const no_home_statsbar_giveawaystodate3 = /** @type {(inputs: Home_Statsbar_Giveawaystodate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaways hittil`)
};

const pl_home_statsbar_giveawaystodate3 = /** @type {(inputs: Home_Statsbar_Giveawaystodate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dotychczasowe rozdania`)
};

const pt_br2_home_statsbar_giveawaystodate3 = /** @type {(inputs: Home_Statsbar_Giveawaystodate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogos grátis até agora`)
};

const pt_home_statsbar_giveawaystodate3 = /** @type {(inputs: Home_Statsbar_Giveawaystodate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertas grátis até à data`)
};

const ro_home_statsbar_giveawaystodate3 = /** @type {(inputs: Home_Statsbar_Giveawaystodate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferte gratuite până acum`)
};

const fi_home_statsbar_giveawaystodate3 = /** @type {(inputs: Home_Statsbar_Giveawaystodate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmaisjaot tähän mennessä`)
};

const sv_home_statsbar_giveawaystodate3 = /** @type {(inputs: Home_Statsbar_Giveawaystodate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utlottningar hittills`)
};

const vi_home_statsbar_giveawaystodate3 = /** @type {(inputs: Home_Statsbar_Giveawaystodate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tặng miễn phí đến nay`)
};

const tr_home_statsbar_giveawaystodate3 = /** @type {(inputs: Home_Statsbar_Giveawaystodate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bugüne Kadarki Bedava Oyunlar`)
};

const cs_home_statsbar_giveawaystodate3 = /** @type {(inputs: Home_Statsbar_Giveawaystodate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dosavadních výprodejů`)
};

const bg_home_statsbar_giveawaystodate3 = /** @type {(inputs: Home_Statsbar_Giveawaystodate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Безплатни игри до момента`)
};

const ru_home_statsbar_giveawaystodate3 = /** @type {(inputs: Home_Statsbar_Giveawaystodate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Раздач за всё время`)
};

const uk_home_statsbar_giveawaystodate3 = /** @type {(inputs: Home_Statsbar_Giveawaystodate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Роздач на сьогодні`)
};

const ar_home_statsbar_giveawaystodate3 = /** @type {(inputs: Home_Statsbar_Giveawaystodate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الهدايا حتى الآن`)
};

const hi_home_statsbar_giveawaystodate3 = /** @type {(inputs: Home_Statsbar_Giveawaystodate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अब तक के गिवअवे`)
};

const th_home_statsbar_giveawaystodate3 = /** @type {(inputs: Home_Statsbar_Giveawaystodate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ของแจกฟรีจนถึงปัจจุบัน`)
};

const ja_home_statsbar_giveawaystodate3 = /** @type {(inputs: Home_Statsbar_Giveawaystodate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配布実績`)
};

const zh_cn2_home_statsbar_giveawaystodate3 = /** @type {(inputs: Home_Statsbar_Giveawaystodate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`累计赠送游戏`)
};

const zh_hant1_home_statsbar_giveawaystodate3 = /** @type {(inputs: Home_Statsbar_Giveawaystodate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`累計贈送遊戲`)
};

const ko_home_statsbar_giveawaystodate3 = /** @type {(inputs: Home_Statsbar_Giveawaystodate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`역대 무료 배포`)
};

/**
* | output |
* | --- |
* | "Giveaways to Date" |
*
* @param {Home_Statsbar_Giveawaystodate3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_statsbar_giveawaystodate3 = /** @type {((inputs?: Home_Statsbar_Giveawaystodate3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Statsbar_Giveawaystodate3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_statsbar_giveawaystodate3(inputs)
	if (locale === "ms") return ms_home_statsbar_giveawaystodate3(inputs)
	if (locale === "da") return da_home_statsbar_giveawaystodate3(inputs)
	if (locale === "de") return de_home_statsbar_giveawaystodate3(inputs)
	if (locale === "en-US") return en_us2_home_statsbar_giveawaystodate3(inputs)
	if (locale === "es-ES") return es_es2_home_statsbar_giveawaystodate3(inputs)
	if (locale === "es-MX") return es_mx2_home_statsbar_giveawaystodate3(inputs)
	if (locale === "fil") return fil_home_statsbar_giveawaystodate3(inputs)
	if (locale === "fr") return fr_home_statsbar_giveawaystodate3(inputs)
	if (locale === "it") return it_home_statsbar_giveawaystodate3(inputs)
	if (locale === "hu") return hu_home_statsbar_giveawaystodate3(inputs)
	if (locale === "nl") return nl_home_statsbar_giveawaystodate3(inputs)
	if (locale === "no") return no_home_statsbar_giveawaystodate3(inputs)
	if (locale === "pl") return pl_home_statsbar_giveawaystodate3(inputs)
	if (locale === "pt-BR") return pt_br2_home_statsbar_giveawaystodate3(inputs)
	if (locale === "pt") return pt_home_statsbar_giveawaystodate3(inputs)
	if (locale === "ro") return ro_home_statsbar_giveawaystodate3(inputs)
	if (locale === "fi") return fi_home_statsbar_giveawaystodate3(inputs)
	if (locale === "sv") return sv_home_statsbar_giveawaystodate3(inputs)
	if (locale === "vi") return vi_home_statsbar_giveawaystodate3(inputs)
	if (locale === "tr") return tr_home_statsbar_giveawaystodate3(inputs)
	if (locale === "cs") return cs_home_statsbar_giveawaystodate3(inputs)
	if (locale === "bg") return bg_home_statsbar_giveawaystodate3(inputs)
	if (locale === "ru") return ru_home_statsbar_giveawaystodate3(inputs)
	if (locale === "uk") return uk_home_statsbar_giveawaystodate3(inputs)
	if (locale === "ar") return ar_home_statsbar_giveawaystodate3(inputs)
	if (locale === "hi") return hi_home_statsbar_giveawaystodate3(inputs)
	if (locale === "th") return th_home_statsbar_giveawaystodate3(inputs)
	if (locale === "ja") return ja_home_statsbar_giveawaystodate3(inputs)
	if (locale === "zh-CN") return zh_cn2_home_statsbar_giveawaystodate3(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_statsbar_giveawaystodate3(inputs)
	return ko_home_statsbar_giveawaystodate3(inputs)
});
export { home_statsbar_giveawaystodate3 as "home.statsBar.giveawaysToDate" }